import React from 'react'
import styled from 'styled-components'

import { Content } from '../../../../layouts/shared/content'

import { ReactComponent as AppleStoreSVG } from './assets/apple-store.svg'
import { ReactComponent as DemoScreenSVG } from './assets/demo-screen.svg'
import { P, Text } from '@mote/ui'

export const MobileAppSection = () => {
  return (
    <Root id='mobile-app-section'>
      <Content>
        <Container>
          <DemoScreenSVG />

          <RightSideContent>
            <Text tag='h3'>New! Mote iOS app 🎉</Text>
            <PStyled>
              Now you can Mote on the go with our iOS app, for iPad and iPhone!
              Record and share motes from the app, or use the integrated
              keyboard to record from apps such as Google Docs and Google
              Classroom.
            </PStyled>
            <a
              href='https://apps.apple.com/us/app/mote/id1568351949'
              target='_new'
            >
              <AppleStoreSVG />
            </a>
          </RightSideContent>
        </Container>
      </Content>
    </Root>
  )
}

const Root = styled.div`
  padding-top: 102px;

  @media (max-width: 991px) {
    padding: 0;
  }
`

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 0 65px;

  @media (max-width: 991px) {
    flex-wrap: wrap;
  }
`

const RightSideContent = styled.div`
  margin-left: 122px;
  display: flex;
  flex-direction: column;
  padding-bottom: 60px;
`

const PStyled = styled(P)`
  width: 100%;
  max-width: 426px;
  margin-bottom: 56px;
`
